export const headers = [
    { text: "ID", align: "center", value: "userName" },
    { text: "이름", align: "center", value: "givenName" },
    { text: "부서", align: "center", value: "department" },
    { text: "직책", align: "center", value: "position" },
    { text: "권한", align: "center", value: "authority", sortable: false },
];
export const permissionHeaders = [
    { text: "페이지 그룹명", align: "center", value: "pageGroupAlias" },
    { text: "페이지명", align: "center", value: "pageAlias" },
    { text: "URL", align: "center", value: "pageUrl" },
    { text: "접근 허용", align: "center", value: "accessAllowed" },
];
